import(/* webpackMode: "eager", webpackExports: ["default"] */ "E:\\vhosts\\paykanpars.com\\httpdocs\\src\\app\\(pages)\\(general)\\terms-of-sale\\components\\terms-of-sale-view.tsx");
